var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-16 text-center font-bold",class:{
    'text-green-500': _vm.isGet,
    'text-orange-500': _vm.isPost,
    'text-blue-500': _vm.isPut,
    'text-red-500': _vm.isDelete,
  }},[_vm._v(" "+_vm._s(_vm.method)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }